import React from "react";

const SymantoAvatar = ({ size = 56 }: { size?: number }) => (
	<img src="/symanto-small-logo.png" width={size} height={size} />
);

export default SymantoAvatar;
